const FEATURE_FLAG_STORAGE_KEY = 'feature_flags';
export const FEATURE_FLAGS = [''] as const;

export type FeatureFlagName = (typeof FEATURE_FLAGS)[number];
export type FeatureFlags = Record<FeatureFlagName, boolean>;

export const getFlags = (): FeatureFlags => {
    const val = localStorage.getItem(FEATURE_FLAG_STORAGE_KEY);
    return JSON.parse(val ?? '{}');
};

export const saveFlags = (flags: Partial<FeatureFlags>) => {
    localStorage.setItem(FEATURE_FLAG_STORAGE_KEY, JSON.stringify(flags));
};
